// export const tableFields = {
//   patientsTable: [
//   ],
//   profilesTable: [

//   ],
//   employeePatientsTable: [
//   ],
//   patientQuotesTable: [ 
//   ]
// }
export const tableHeaders = {
  patientsTable: [
    { name: "ID", cName: "d-none d-lg-table-cell", columnName: "id" }, { name: "RUT", cName: "d-table-cell", columnName: "rut" },
    { name: "Nombre", cName: "d-table-cell", columnName: "name" }, { name: "Apellidos", cName: "d-none d-sm-table-cell", columnName: "lastnames" },
    { name: "Telefono", cName: "d-none d-md-table-cell", columnName: "phone" }, { name: "Edad", cName: "d-none d-lg-table-cell", columnName: "age" },
    { name: "Email", cName: "d-none d-lg-table-cell", columnName: "email" }, { name: "Sexo", cName: "d-none d-lg-table-cell", columnName: "sex" },
    { name: "Previsión", cName: "d-none d-md-table-cell", columnName: "prevision" }, { name: "Nacionalidad", cName: "d-none d-xl-table-cell", columnName: "country" },
    { name: "Detalles", cName: "d-table-cell" }
  ],
  profilesTable: [
    { name: "ID", cName: "d-none d-lg-table-cell", columnName: "id" }, { name: "RUT", cName: "d-none d-lg-table-cell", columnName: "rut" },
    { name: "Nombre", cName: "d-table-cell", columnName: "name" }, { name: "Apellidos", cName: "d-table-cell", columnName: "lastnames" },
    { name: "Telefono", cName: "d-table-cell", columnName: "phone" }, { name: "Cargo", cName: "d-none d-md-table-cell", columnName: "occupation" },
    { name: "Email", cName: "d-table-cell", columnName: "email" }, { name: "Modelo Perfil", cName: "d-none d-md-table-cell", columnName: "profile_type" },
    { name: "Detalles", cName: "d-table-cell" }
  ],
  employeePatientsTable: [
    { name: "ID", cName: "d-none d-lg-table-cell", columnName: "id" }, { name: "RUT o DNI", cName: "d-table-cell", columnName: "rut" },
    { name: "Nombre y Apellidos", cName: "d-table-cell", columnName: "paciente" }, { name: "Cantidad Citas", cName: "d-none d-lg-table-cell", columnName: "citas" },
    { name: "Asistencias", cName: "d-none d-md-table-cell", columnName: "assistance_confirmed" }, { name: "Precio Total", cName: "d-table-cell", columnName: "price" },
    { name: "Pagado", cName: "d-none d-md-table-cell", columnName: "payed" }, { name: "Pendiente", cName: "d-table-cell", columnName: "pending" },
    { name: "Suspendidos", cName: "d-none d-lg-table-cell", columnName: "suspended" }, { name: "Detalles", cName: "d-table-cell" }
  ],
  patientQuotesTable: [
    { name: "ID", cName: "d-table-cell", columnName: "id" }, { name: "Servicio", cName: "d-table-cell", columnName: "service" },
    { name: "Citas", cName: "d-table-cell", columnName: "citas" }, { name: "Asistido", cName: "d-table-cell", columnName: "assistance_confirmed" },
    { name: "Precio", cName: "d-table-cell", columnName: "price" }, { name: "Pagado", cName: "d-table-cell", columnName: "payed" },
    { name: "Pendiente", cName: "d-table-cell", columnName: "pending" }, { name: "Suspendido", cName: "d-table-cell", columnName: "suspended" },
    { name: "Detalles", cName: "d-table-cell" }
  ],
  quoteTable: [
    { name: "ID", cName: "d-none d-lg-table-cell", columnName: "id" }, { name: "Fecha", cName: "d-table-cell", columnName: "date" },
    { name: "Hora", cName: "d-table-cell", columnName: "hour" }, { name: "Servicio", cName: "d-table-cell", columnName: "service_name" },
    { name: "Kinesiologo", cName: "d-none d-md-table-cell", columnName: "professional_name" }, { name: "Paciente", cName: "d-none", columnName: "patient_name" },
    { name: "Asistencia", cName: "d-table-cell", columnName: "asistence" }, { name: "Detalles", cName: "d-table-cell" }
  ],
  transactionsTable: [
    { name: "ID", cName: "d-none d-md-table-cell", columnName: "id" }, { name: "Fecha", cName: "d-table-cell", columnName: "created" },
    { name: "Persona/Ente", cName: "d-table-cell", columnName: "entity_name" }, { name: "Cobrador", cName: "d-none d-lg-table-cell", columnName: "profile" },
    { name: "Categoria", cName: "d-table-cell", columnName: "active_category" }, { name: "Precio", cName: "d-table-cell", columnName: "price" },
    { name: "Cantidad", cName: "d-none d-md-table-cell", columnName: "amount" }, { name: "Tipo Pago", cName: "d-none d-lg-table-cell", columnName: "payment_type" },
    { name: "Editar", cName: "d-table-cell" }
  ],
  activesTable: [
    { name: "ID", cName: "d-none d-md-table-cell", columnName: "id" }, { name: "Nombre", cName: "d-table-cell", columnName: "name" },
    { name: "Subcategoria", cName: "d-none", columnName: "subcategory" }, { name: "Precio Unitario", cName: "d-table-cell", columnName: "price" },
    { name: "Descripción", cName: "d-none d-xl-table-cell", columnName: "details" }, { name: "Editar", cName: "d-table-cell" }
  ],
  subcategoriesTable: [
    { name: "ID", cName: "d-none d-md-table-cell", columnName: "id" }, { name: "Nombre", cName: "d-table-cell", columnName: "name" },
    { name: "Tipo", cName: "d-table-cell", columnName: "type" },
    { name: "Editar", cName: "d-table-cell" }
  ],
}